export default "__VITE_ASSET__eglizu7q__"